// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.\
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './icons' // icon
import '@/styles/index.scss' // global css
// import '@/styles/theme/index.css'
import './permission' // permission control
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/scss/font-awesome.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import vueEventCalendar from '@/views/dashboard/calendar/index.js'
import OAComponents from '@oa/components'
import { toLogin } from '@/utils/toLogin'
import baseLayoutRow from '@/components/baseLayout/baseLayoutRow'
import baseLayoutCol from '@/components/baseLayout/baseLayoutCol'
import tableUnit from '@/components/tableUnit'
import formDialog from '@/components/tableUnit/components/formDialog'
import '@/assets/icon/iconfont.css'

Vue.use(ElementUI, {
  size: 'mini'
})
// Vue.use(QRCode)
Vue.use(VueAwesomeSwiper)
Vue.use(vueEventCalendar)
Vue.use(OAComponents)
Vue.config.productionTip = false
Vue.component('base-layout-row', baseLayoutRow)
Vue.component('base-layout-col', baseLayoutCol)
Vue.component('table-unit', tableUnit)
Vue.component('form-dialog', formDialog)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})
window.addEventListener(
  'message',
  function (messageEvent) {
    var data = messageEvent.data
    if (data === 'logout' || data === '208') {
      ElementUI.MessageBox.confirm(
        '你已被登出，可以取消继续留在该页面，或者重新登录',
        '确定登出',
        {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        store.dispatch('FedLogOut').then(() => {
          toLogin()
          // router.push('/login')
          // location.href = `${location.protocol}${location.host}${location.pathname}#/login`
        })
      })
    }
  },
  false
)



// WEBPACK FOOTER //
// ./src/main.js